// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { myAccountViewStyles } from "@sc/Overrides/Widgets/MyAccount/MyAccountView";
import LogOut from "@sc/XDL/Icons/LogOut";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

myAccountViewStyles.quickLinksGridItem = {
    width: [12, 12, 12, 3, 3],
    css: css`
        flex-direction: column;
    `,
};

myAccountViewStyles.actionSection = {
    wrapper: {
        css: css`
            margin-top: 12px;
            padding-top: 12px;
            border-top: 1px solid ${color("common.border")};
        `,
    },

    signOutButton: {
        css: css`
            display: flex;
            margin-bottom: 8px;
        `,
        typographyProps: {
            size: 12,
            lineHeight: "17px",
            color: "common.ui4",
            weight: fontConfig.weight.bold,
        },
        icon: {
            iconProps: { src: LogOut, size: 12 },
            position: "left",
        },
    },
};

myAccountViewStyles.linksBox = {
    container: {
        css: css`
            width: 100%;
        `,
    },
};

myAccountViewStyles.mainSectionGridItem = { width: [12, 12, 12, 9, 9] };

myAccountViewStyles.pageTitleGridItem = {
    width: 12,
    css: css`
        ${TypographyStyle} {
            margin-bottom: 0;
        }
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

myAccountViewStyles.midTitleGridItem = {
    width: 12,
    css: css`
        ${TypographyStyle} {
            margin-bottom: 0;
        }
        display: none;
        ${xScreen("lte", "md")} {
            display: block;
        }
    `,
};

myAccountViewStyles.makeDashboardMyHomePageGridItem = {
    width: 12,
    css: css`
        align-items: center;
    `,
};

myAccountViewStyles.accountMessagesGridItem = {
    width: 12,
};

myAccountViewStyles.dashboardSummaryGridItem = {
    width: 12,
};

myAccountViewStyles.container = {
    gap: 42,
};

myAccountViewStyles.mainContainer = {
    gap: 20,
};
